export const SHIPPING_METHOD_TYPE_DEFAULT_PICKUP = 0;
export const SHIPPING_METHOD_TYPE_SHIPPING_COMPANY = 1;
export const SHIPPING_METHOD_TYPE_CUSTOM_PICKUP = 2;
